import http from './httpService';
import config from '../configs/config.js';
import references from '../configs/reference.json';

const url = config.summaryapiEndPoint;
const narrativeEndPoint = config.apiEndPoint + '/narratives';
const narrativeCashEndPoint = config.apiEndPoint + '/narratives-cash';
const narrativeBankEndPoint = config.apiEndPoint + '/narratives-bank';

function generateURL(path) {
  return `${url}/${path}`;
}

// ------------------------------- SUMMARY SERVICE -------------------------------------------- //
// 1. Get descriptive summary for user
export async function getDescriptiveSummary(id, type = 'genai') {
  let summary = await http.get(generateURL('descriptive/' + id), {
    params: { type: type }
  });
  references.forEach(function (val) {
    summary.data.forEach(function (data) {
      data.level = data.level.replaceAll(val.from, val.to);
      data.summary = data.summary.replaceAll(val.from, val.to);
    });
  });
  return summary;
}

// 2. Get alert summary for user
export async function getAlertSummary(id, type = 'template') {
  let summary = await http.get(generateURL('alert/' + id), {
    params: { type: type }
  });
  references.forEach(function (val) {
    summary.data.forEach(function (data) {
      data.level = data.level.replaceAll(val.from, val.to);
      data.summary = data.summary.replaceAll(val.from, val.to);
    });
  });
  return summary;
}

// 3. Get insights & actions for user
export async function getInsightActions(id, type = 'landing') {
  let actions = await http.get(generateURL('insightactions/' + id), {
    params: { type: type }
  });
  references.forEach(function (val) {
    actions.data.forEach(function (data) {
      data.aan_name = data.aan_name.replaceAll(val.from, val.to);
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
  return actions;
}

// ------------------------------- CORE API SERVICE -------------------------------------------- //
// 1. Get narratives from db
export async function getNarrativefromDb() {
  const narrative = await http.get(narrativeEndPoint);
  return narrative;
}

export async function getNarrativeCashfromDb() {
  const narrative = await http.get(narrativeCashEndPoint);
  return narrative;
}

export async function getNarrativeBankfromDb() {
  const narrative = await http.get(narrativeBankEndPoint);
  return narrative;
}